import { Props } from 'props';
import AppProvider, { useApp } from './app';
import AuthProvider, { useAuth } from './auth';
import AlertProvider, { useAlert } from './alert';
import ModelProvider, { useModel } from './model';
import DossierProvider, { useDossier } from './dossier';
import CollaboratorUserProvider, {
  useCollaboratorUser,
} from './collaboratorUser';
import CompanyUserProvider, { useCompanyUser } from './companyUser';
import CommercialPlanProvider, {
  useCommercialPlan,
} from './commercialPlan';
import LogUserProvider, { useLogUser } from './logUser';
import PaymentProvider from './payment';
import FontMonitoringProvider from './fontMonitoring';
import { ConfigProvider } from 'antd';
import locale from 'antd/locale/pt_BR';
import ExternalFontProvider, {
  useExternalFont,
} from './externalFontContext';
import RiskMatrixProvider from './riskMatrix';
export {
  useApp,
  useAuth,
  useAlert,
  useModel,
  useDossier,
  useCollaboratorUser,
  useCompanyUser,
  useCommercialPlan,
  useLogUser,
  useExternalFont,
};

const GlobalContext: React.FC<Props> = ({ children }: Props) => {
  return (
    <AppProvider>
      <AlertProvider>
        <AuthProvider>
          <LogUserProvider>
            <ExternalFontProvider>
              <DossierProvider>
                <CompanyUserProvider>
                  <CollaboratorUserProvider>
                    <RiskMatrixProvider>
                      <ModelProvider>
                        <PaymentProvider>
                          <FontMonitoringProvider>
                            <CommercialPlanProvider>
                              <ConfigProvider
                                locale={locale}
                                theme={{
                                  token: {
                                    colorPrimary: '#293778',
                                  },
                                }}
                              >
                                {children}
                              </ConfigProvider>
                            </CommercialPlanProvider>
                          </FontMonitoringProvider>
                        </PaymentProvider>
                      </ModelProvider>
                    </RiskMatrixProvider>
                  </CollaboratorUserProvider>
                </CompanyUserProvider>
              </DossierProvider>
            </ExternalFontProvider>
          </LogUserProvider>
        </AuthProvider>
      </AlertProvider>
    </AppProvider>
  );
};

export default GlobalContext;
